exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ver h1,.ver h2,.ver h3{font-weight:700;margin-top:4px}.ver h1{font-size:20px}.ver h2{font-size:17px}.ver h3{font-size:15px;margin-top:20px}.ver ul{padding-left:20px}.ver ul li{list-style:disc}.ver ol{padding-left:28px;margin-bottom:8px}", ""]);

// exports
